@if(type == 'project'){
  <ng-template #nzModalTitle>
    Project Detail
    <button nz-button nzType="default" *ngIf="isConsolePage" (click)="redirectToConsole(tabData, 'project')" style="margin-right:30px;float:inline-end"
    [nzSize]="'small'"  nzType="default">
      <nz-icon nzType="export" nzTheme="outline" />
   </button> 
    <button nz-button nzType="default" (click)="editProject(tabData)" style="margin-right:30px;float:inline-end"
    [nzSize]="'small'" nzType="default">
      <nz-icon nzType="edit" nzTheme="outline" />
   </button> 
  </ng-template>
  
  <nz-modal [(nzVisible)]="isVisible" [nzFooter]="null" [nzWidth]="'100vw'" [nzClosable]="true" [nzTitle]="nzModalTitle"
    (nzOnCancel)="handleCancel()" nzClassName="fullscreen-modal"  [nzStyle]="{ top: '30px' }">
    <div class="modal-content" *nzModalContent>
  
      <nz-row class="custom-row" style="padding: 0px;">
        <!-- Left Column -->
        <nz-col [nzSpan]="8" class="left-col">
          <div class="content-box">
            <nz-descriptions [nzColumn]="1" nzSize="middle" nzBordered>
              <nz-descriptions-item nzTitle="Project ID"><nz-tag>{{ formatIdToFourDigits(tabData?.id , 'PR')  }}</nz-tag></nz-descriptions-item>
              <nz-descriptions-item nzTitle="Status">
                <nz-badge nzStatus="processing" *ngIf="tabData.status_name"
                [nzText]="tabData.status_name"></nz-badge> 
                
              </nz-descriptions-item>
              <nz-descriptions-item nzTitle="Project Name"><a href="javascript:void(0)"> {{ tabData?.name}} </a></nz-descriptions-item>
              <nz-descriptions-item nzTitle="Client">
                <a href="javascript:void(0)"> {{ tabData?.client_name}}   </a>
              </nz-descriptions-item>
              <nz-descriptions-item nzTitle="Due Date"> {{ tabData?.due_date | date:'yyyy-MM-dd' }} </nz-descriptions-item>
  
              <nz-descriptions-item nzTitle="Assign To"> {{ tabData?.assign_to_name}} </nz-descriptions-item>
              <nz-descriptions-item nzTitle="Assign To Group"> {{ tabData?.assigned_to_group_name}} </nz-descriptions-item>
              <nz-descriptions-item nzTitle="CSM">  {{ tabData?.customer_success_manager_name}} </nz-descriptions-item>
              <nz-descriptions-item nzTitle="Created At"> {{ tabData?.created_at | date:'yyyy-MM-dd' }} </nz-descriptions-item>
              <nz-descriptions-item nzTitle="Created By"> {{ getNameById(tabData?.created_by) }} </nz-descriptions-item>
  
            </nz-descriptions>
          </div>
        </nz-col>
  
        <!-- Right Column (Overlapping) -->
        <nz-col [nzSpan]="16" class="right-col">
          <div class="overlap-box">
            <nz-layout style="height: 100%;">
              <!-- Sidebar -->
              <nz-sider nzWidth="135px" nzTheme="light" [nzCollapsible]="false" 
              style="background: #ffffff; height: 100%; overflow: none;">
                <ul nz-menu nzTheme="light" nzMode="inline" [nzInlineCollapsed]="true" style="height: 100%; ">
                  <li nz-menu-item *ngFor="let item of sideMenus;"  [nzSelected]="selectedTab == item.value"
                  [ngClass]="selectedTab == item.value ? 'ant-menu-item-selected':''" (click)="selectedTab = item.value">
                    <i nz-icon [nzType]="item.icon"></i> {{item?.label}}
                  </li>
                </ul>
              </nz-sider>
  
              <!-- Content Area -->
              <nz-layout>
                <nz-content style="padding: 16px; background: #fff; border-radius: 0 8px 8px 0;">
                  <ng-container [ngSwitch]="selectedTab">
                    <div *ngSwitchCase="'overview'">
                        <app-cpd-overview [desc]="tabData.description" [projectId]="tabData.id"></app-cpd-overview>
                    </div>
                    <div *ngSwitchCase="'tasks'">
                      <app-cpd-tasks [data]="tabData" (openTaskDetailEvent)="openTaskDetail($event)"></app-cpd-tasks>
                    </div>
                    <div *ngSwitchCase="'people'">
                      <app-cpd-people [project_client]="tabData.project_client"></app-cpd-people>
                    </div>
                    <div *ngSwitchCase="'events'">
                      <app-cpd-events [project_id]="tabData.id"></app-cpd-events>
                    </div>
                    <div *ngSwitchCase="'files'" >
                      <app-cpd-files [data]="tabData" (filesChanged)="onFilesChanged($event)"></app-cpd-files>
                    </div>
                    <div *ngSwitchCase="'drive_links'">
                      <app-cpd-drive-links [projectLinks]="tabData.link_details" [project]="tabData"
                       (linksChanged)="onLinksChanged($event)"></app-cpd-drive-links>
                    </div>
                    <div *ngSwitchCase="'history'">
                      <app-cpd-history [projectId]="tabData.id" ></app-cpd-history>
                    </div>
                    <div *ngSwitchDefault>
                      <app-cpd-overview></app-cpd-overview>
                    </div>
                  </ng-container>
                </nz-content>
              </nz-layout>
  
            </nz-layout>
  
          </div>
        </nz-col>
      </nz-row>
  
  
    </div>
  </nz-modal>
  
} @else {
  <ng-template #nzModalTitle2>
  
   <div style="display: flex; align-items: center;justify-content: space-between;">
    <div > 
        📋 Task Details
    </div>
    <div style="margin-right:30px"> 
        <button nz-button nzType="default" style="margin-right:0px;" (click)="editTask(tabData)" [nzSize]="'small'">
            <nz-icon nzType="edit" nzTheme="fill" />
        </button> 
        <!-- <button nz-button nzType="default"  (click)="deleteTask(tabData)">
            <nz-icon nzType="delete" nzTheme="fill"  />
        </button>  -->
    </div>
</div>
  </ng-template>
  
  <nz-modal [(nzVisible)]="isVisible" [nzFooter]="null" [nzWidth]="'100vw'" [nzClosable]="true" [nzTitle]="nzModalTitle2"
    (nzOnCancel)="handleCancel()" nzClassName="fullscreen-modal"  [nzStyle]="{ top: '30px'}"
    nzFooter="null">
    <div class="modal-content" *nzModalContent>
      <app-console-task-tab  [tabData]="tabData" [showTaskHeader]="false"></app-console-task-tab>
      </div>
  </nz-modal>   
}

